import React, { useState, useEffect } from "react";
import axios from "axios";
import { Spin } from "antd";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import "../team/teamModal.css";

const ViewTeamLeadDetails = ({ setOpen, teamId }) => {
  const [teamleadData, setTeamleadData] = useState(null);
  const teamleadAPI = process.env.REACT_APP_API_Teamleads;

  useEffect(() => {
    const fetchTeamDetails = async () => {
      try {
        const response = await axios.get(`${teamleadAPI}/${teamId}`);
        setTeamleadData(response.data.body);
      } catch (error) {
        console.error("Error fetching team details:", error);
      }
    };

    fetchTeamDetails();
    return () => {
      setTeamleadData(null);
    };
  }, [teamId, teamleadAPI]);

  if (!teamleadData) {
    return (
      <div className="team-modal-loading" style={{ padding: 48 }}>
        <Spin size="large" />
      </div>
    );
  }

  const fields = [
    { label: "Teamlead ID", value: teamleadData.id },
    { label: "Teamlead Name", value: `${teamleadData.first_name || ""} ${teamleadData.last_name || ""}`.trim() },
    { label: "Contact Number", value: teamleadData.contact_number },
    { label: "Email", value: teamleadData.email },
  ];

  return (
    <>
      <AppBar className="team-modal-appbar" position="relative">
        <Toolbar>
          <Typography className="team-modal-title" variant="h6" component="div" sx={{ flex: 1 }}>
            Team Lead Details
          </Typography>
          <IconButton
            edge="end"
            color="inherit"
            onClick={() => setOpen(false)}
            aria-label="close"
            className="team-modal-close-btn"
          >
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <div className="view-detail-body">
        <div className="view-detail-cards">
          {fields.map(({ label, value }) => (
            <div key={label} className="view-detail-row">
              <span className="team-detail-label">{label}</span>
              <span className="team-detail-value">{value ?? "—"}</span>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default ViewTeamLeadDetails;
